import * as tslib_1 from "tslib";
/* tslint:disable */
import * as React from 'react';
import { css } from '../../../Utilities';
/* tslint:enable */
import { BasePicker } from '../BasePicker';
import { TagItem } from './TagItem';
import * as stylesImport from './TagItem.scss';
var styles = stylesImport;
var TagPicker = /** @class */ (function (_super) {
    tslib_1.__extends(TagPicker, _super);
    function TagPicker() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TagPicker.defaultProps = {
        onRenderItem: function (props) {
            return React.createElement(TagItem, tslib_1.__assign({}, props), props.item.name);
        },
        onRenderSuggestionsItem: function (props) { return (React.createElement("div", { className: css('ms-TagItem-TextOverflow', styles.tagItemTextOverflow) },
            " ",
            props.name,
            " ")); }
    };
    return TagPicker;
}(BasePicker));
export { TagPicker };
//# sourceMappingURL=TagPicker.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/office-ui-fabric-react/lib/components/pickers/TagPicker/TagPicker.js
// module id = 820
// module chunks = 0